import React from "react";
import MainLayout from "../components/layouts/MainLayout";
import { PatientMonitoringWidget } from "../components/customReporting/PatientMonitoringWidget";
import { ProfileService } from "../services/profile.service";
import { hasAccess, ROLES } from "../utils/roles";

export const ARManagementPage: React.FC = () => {
  const userRoles = ProfileService.getUserProfileFromStorage()?.roles ?? [];
  const canPatientMonitor = hasAccess(userRoles, [
    ROLES.AR_MANAGEMENT_WIDGET_PATIENT_MONITORING,
    ROLES.AR_MANAGEMENT_ADMIN,
    ROLES.AR_MANAGEMENT_USER,
  ]);

  return (
    <MainLayout>
      <main className="flex-1 min-w-0 relative md:ml-0 ml-12">
        <div className="p-4 md:p-6">{canPatientMonitor && <PatientMonitoringWidget />}</div>
      </main>
    </MainLayout>
  );
};
